import request from '@/utils/request'
const apiPath = '/sys/sysGoodsSpec'
const sysGoodsSpecApi = {
  /**
   * 新增【商品规格类型】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品规格类型】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品规格类型】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【商品规格类型】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【商品规格类型】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  updateDeleted(data) {
    return request.post(apiPath + '/updateDeleted', data, {isFormData: 1})
  },
}
export default sysGoodsSpecApi
